export default "__VITE_ASSET__f0d2858b__"